<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
<!--            <slot name="new_btn">-->
<!--              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>-->
<!--            </slot>-->
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
            <Button type="error" class="search-btn" @click="perinbox_list(4)">批量不录用</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem label="操作" prop="Pname">
                <el-select
                  v-model="formValidate.bid"
                  filterable
                  default-first-option
                  placeholder="请选择需要的业务操作">
                  <el-option
                    v-for="item in formValidate.bussinesss"
                    :key="item.id"
                    :label="item.bname"
                    :value="item.id">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="说明">
                <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入情况描述" />
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
    <el-drawer
      title="个人信息"
      :visible.sync="msgmodal"
      direction="ltr"
      size="30%">
      <el-divider></el-divider>

      <el-form ref="form" :model="formValidate_per" label-width="100px">

        <el-form-item label="姓名：">
          {{ formValidate_per.Pname }}
        </el-form-item>
        <el-form-item label="性别：">
          {{ formValidate_per.Psex_CN }}
        </el-form-item>
        <el-form-item label="年龄：">
          {{ formValidate_per.age }}
        </el-form-item>
        <el-form-item label="身份证：">
          {{ formValidate_per.Pidcard }}
        </el-form-item>
        <el-form-item label="地址：">
          {{ formValidate_per.Paddress }}
        </el-form-item>
        <el-form-item label="现居住区域：">
          {{ formValidate_per.Pnowaddress }}
        </el-form-item>
        <el-form-item label="电话：">
          {{ formValidate_per.Pphone }}
        </el-form-item>
        <el-form-item label="婚姻：">
          {{ formValidate_per.Pmarriage_CN }}
        </el-form-item>
        <el-form-item label="民族：">
          {{ formValidate_per.Pnation_CN }}
        </el-form-item>
        <el-form-item label="学历：">
          {{ formValidate_per.Peducation_CN }}
        </el-form-item>
        <el-form-item label="工作年限：">
          {{ formValidate_per.Pexperience_CN }}
        </el-form-item>

        <el-form-item label="期望薪酬：">
          {{ formValidate_per.Psalary_CN }}
        </el-form-item>
        <el-form-item label="简历：">
          <el-image
            style="width: 100px; height: 100px"
            :src="formValidate_per.perpic"
            :preview-src-list="formValidate_per.perpiclist">
          </el-image>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>

</template>
<script>

import {
  getHrbusinessinfolist,
  operationHrbusinessinfo,
} from '@/api/hr/hrbusinessinfo.js'
import {getsysparameterList} from "@/api/system/sys_parameter";
import {perinbox} from "@/api/apply/apply";

let moment = require("moment");
export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: "",
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      msgmodal:false,
      formValidate_per: {},
      tableSelectIdList: [],
      editModalData: "",
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数
      formData:{},
      ruleValidate: {
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: "姓名",
          key: "Pname",
          fixed: "left",
          align: "center",
          width: 120,
          sortable: true,
          render: (h, params) => {
            return h('a', {
                on: {
                  click: () => {
                    this.perinfo_show(params.row.perinfo)
                  }
                }
              }, params.row.Pname
            )
          }},
        {
          title: "单位",
          key: "Cname",
          align: "center",
          width: 250,
          sortable: true },
        {
          title: "岗位",
          key: "Jobname",
          align: "center",
          width: 120,
          sortable: true },
        {
          title: "状态",
          key: "Astate_CN",
          align: "center",
          width: 120,
          sortable: true },
        {
          title: "投简时间",
          key: "Aintime",
          align: "center",
          width: 150,
          sortable: true },
        {
          title: "来源",
          key: "Atype_CN",
          align: "center",
          width: 120,
          sortable: true },
        {
          title: "待处理",
          key: "bstate",
          align: "center",
          width: 120,
          sortable: true }
,        {
          title: "操作",
          key: "handle",
          fixed: "right",
          width: 300,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, "post", "业务操作");
                    }
                  }
                },
                "业务操作"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.perinbox(params.row, 3);
                    }
                  }
                },
                "拟录用"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.perinbox(params.row, 4);
                    }
                  }
                },
                "不录用"
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getHrbusinessinfolist(key, value) {
      this.spinShow = true
      getHrbusinessinfolist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList() {
    },
    handleSelectChange(val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal() {
      this.dialog.show = false
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      // this.getParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      // console.log(paramsRow)
      if (paramsRow && paramsRow.Id) {
        this.formValidate = paramsRow
        // console.log(this.formValidate)
      } else {
        this.formValidate = {
          id: 0,
        }
        // console.log(this.formValidate)
      }
    },
    perinfo_show(val) {
      this.msgmodal = true
      this.formValidate_per = val
    },

    handleSubmit(value) {
      // console.log(this.$refs[value].validate)
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.aid = this.formValidate.Id
            operationHrbusinessinfo(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getHrbusinessinfolist(this.searchVal)
                } else {
                  this.getHrbusinessinfolist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handlerDelete() {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationHrbusinessinfo({'id_list': this.tableSelectIdList}, 'delete').then(            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getHrbusinessinfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    perinbox_list (Iresult) {
      let that = this
      if (that.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量不录用选中数据嘛？ `)) {
          perinbox({'id_list': that.tableSelectIdList, 'Astate': Iresult}).then(
            res => {
              if (res.data.code === 0) {
                that.$Message.success(`${res.data.msg}`)
                that.getHrbusinessinfolist(that.searchVal)
              } else {
                that.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        that.$Message.info(`你总要选中点什么吧`)
      }
    },
    perinbox (row, Iresult) {
      let that = this
      row.Astate = Iresult
      perinbox(row).then(res => {
        if (res.data.code === 0) {
          that.getHrbusinessinfolist()
          // that.getperjob(that.formValidate_company.Id)
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationHrbusinessinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage(value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getHrbusinessinfolist(this.searchVal)
      } else {
        this.getHrbusinessinfolist()
      }
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getHrbusinessinfolist(this.searchVal)
      } else {
        this.getHrbusinessinfolist()
      }
    },
    searchinput() {
      if (this.searchVal) {
        this.getHrbusinessinfolist(this.searchVal)
      } else {
        this.getHrbusinessinfolist()
      }
    }
  },
  watch: {
    searchVal(val) {
      this.searchVal = val
    }
  },
  mounted() {
    this.getHrbusinessinfolist();
  }
}
</script>
<style lang="css" >
.el-drawer {
  overflow: auto;
}
</style>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
